import { ValidationError } from 'yup';
import { IOrderQuotation } from '../order-quotation-form';

// A free line (product === null) must carry a non-empty specification — it is
// the only description the printed PDF has, and an empty one is refused. A
// linked line renders the product's description, so the free text is ignored.
export function isProposedDescriptionRequired(
    value: any,
    context: any,
): boolean | ValidationError {
    const { product, proposed_description } = context.from[0]
        .value as IOrderQuotation['order_quotation_products'][number];

    if (product) return true;

    if (!proposed_description || String(proposed_description).trim() === '') {
        return context.createError({
            message: `'Especificación' es obligatoria en una línea libre`,
        });
    }

    return true;
}
